export default __webpack_public_path__ + "components/weather-icon/static/nightheavyrain-598442865afd1d418e8c713f0665d2a4.png";